import { defineStore } from 'pinia'
import axios from 'axios'
import useMainStore from '@/stores/main'

export default defineStore('notes', {
    state: () => {
        return {
            notes: [],
            currentNote: {},
            showDeleteModal: false,
            showNewNote: false,
            currentNoteID: '',
        }
    },
    computed: {

    },
    actions: {
        async addNote(course_id, module_id, video_id, module_name, url, time, body) {

            if (body == '') {
                return alert('You must enter a note.')
            }
            const mainStore = useMainStore()

            await axios
                .post(`${import.meta.env.VITE_BASE_LINK}/addNote`, {
                    apiKey: 'EjuoZZcumh1SQwCX1LuiLDbpusDue2k64CtVXcgLjXFDTMxPvif1498TPHWXcGW9',
                    user_email: mainStore.user.email,
                    title: module_name,
                    course_id: course_id,
                    module_id: module_id,
                    video_id: video_id,
                    url: url,
                    body: body,
                    time: time,
                    timeToDisplay: mainStore.currentVideoTimeDisplay,
                    marker: mainStore.markerTime
                })
                .then(async response => {
                    if (response.data.code == 200) {
                        this.showNewNote = false
                        await this.getNotes()
                    } else {
                        alert(response.data.message)
                    }
                })
                .catch(function (error) {
                    alert(error);
                });
        },
        async getNotes() {
            
            const mainStore = useMainStore()

            await axios
                .post(`${import.meta.env.VITE_BASE_LINK}/getNotes`, {
                    apiKey: 'EjuoZZcumh1SQwCX1LuiLDbpusDue2k64CtVXcgLjXFDTMxPvif1498TPHWXcGW9',
                    user_email: mainStore.user.email,
                    course_id: mainStore.selected_course.id || ''
                })
                .then(response => {
                    this.notes = []
                    this.notes = response.data
                    mainStore.course_notes = []
                    for (var note of this.notes) {
                        mainStore.course_notes.push({
                            id: note.video_id,
                            module_id: note.module_id,
                            note_id: note.id,
                            time: note.time,
                            timeToDisplay: note.timeToDisplay,
                            text: note.body,
                        })
                    }
                }).catch(error => {
                    alert(response.data.message)
                })
        },
        async deleteNote(id) {
            await axios
                .post(`${import.meta.env.VITE_BASE_LINK}/deleteNote`, {
                    apiKey: 'EjuoZZcumh1SQwCX1LuiLDbpusDue2k64CtVXcgLjXFDTMxPvif1498TPHWXcGW9',
                    id: id
                })
                .then(response => {
                    this.showDeleteModal = false
                    this.getNotes()
                }).catch(error => {
                    alert(response.data.message)
                })
        }
    },

})